<div class="p-fluid">
  <form #unitForm="ngForm" (ngSubmit)="onSubmit(unitForm)">
    <div class="p-grid p-formgrid">
      <div class="col-12 d-flex align-items-center">
        <div class="form-group col-6 p-1">
          <label for="unitName">Unit Name</label>
          <input id="unitName" type="text" pInputText name="unitName" [(ngModel)]="unit.unit" required />
        </div>
        <div class="form-group col-6 p-1">
          <label for="unitName">Floor Plan</label>
          <p-dropdown [options]="floorPlan" placeholder="Select Plan" [(ngModel)]="unit.floor_plan_id" name="floorPlan"
            optionLabel="unit" optionValue="_id" filter="true" (onChange)="onFloorPlanChange($event)">
          </p-dropdown>
        </div>
      </div>

      <div class="col-12 d-flex align-items-center">
        <div class="form-group col-6 p-1">
          <label for="minPrice">Min Price</label>
          <input id="minPrice" type="number" pInputText name="minPrice" [(ngModel)]="unit.min_price"
            (input)="validateNumber($event)" (blur)="validateMinMax()" min="1" required />
        </div>
        <div class="form-group col-6 p-1">
          <label for="maxPrice">Max Price</label>
          <input id="maxPrice" type="number" pInputText name="maxPrice" [(ngModel)]="unit.max_price"
            (input)="validateNumber($event)" (blur)="validateMinMax()" min="1" required />
        </div>
      </div>

      <div class="col-12 d-flex align-items-center">
        <div class="form-group col-6 p-1">
          <label for="sqFt">Square Feet</label>
          <input id="sqFt" type="number" pInputText name="sqFt" [(ngModel)]="unit.sq_ft"
            (input)="validateNumber($event)" [disabled]="true" required />
        </div>
        <div class="form-group col-6 p-1">
          <label for="unitName">Select Tenant</label>
          <p-dropdown [options]="tenants" placeholder="Select Tenant" [(ngModel)]="unit.tenant_id" name="tenant"
            optionLabel="label" optionValue="_id" filter="true">
          </p-dropdown>
        </div>
      </div>

      <div class="col-12 d-flex align-items-center">
        <div class="form-group col-6 p-1">
          <label for="beds">Beds</label>
          <input id="beds" type="number" pInputText name="beds" [(ngModel)]="unit.beds" [disabled]="true" required />
        </div>
        <div class="form-group col-6 p-1">
          <label for="baths">Baths</label>
          <input id="baths" type="number" pInputText name="baths" [(ngModel)]="unit.baths" [disabled]="true" required />
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="form-group">
            <label for="availablity_date">Availability From</label>
            <select class="form-control" [(ngModel)]="unit.availability_status" name="availability_status"
              (change)="onAvailabilityChange()">
              <option value="{{AvailabilityStatus.DATE}}">{{AvailabilityStatusText.DATE}}</option>
              <option value="{{AvailabilityStatus.AVAILABLENOW}}">{{AvailabilityStatusText.AVAILABLENOW}}</option>
              <option value="{{AvailabilityStatus.NOTAVAILABLE}}">{{AvailabilityStatusText.NOTAVAILABLE}}</option>
            </select>
            <p-calendar id="availablity_date" [(ngModel)]="unit.availablity_date" name="availabilityFrom"
              [iconDisplay]="'input'" [showIcon]="true" dateFormat="mm/dd/yy" [disabled]="availabilityDisabled"
              [minDate]="minDate" required (onSelect)="updateVisibilityMinDate()"></p-calendar>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label for="visibility_date">Visibility From</label>
            <select class="form-control" [(ngModel)]="unit.visibility_status" name="visibility_status"
              (change)="onVisibilityChange()">
              <option value="{{VisibilityStatus.DATE}}">{{VisibilityStatusText.DATE}}</option>
              <option value="{{VisibilityStatus.VISIBLENOW}}">{{VisibilityStatusText.VISIBLENOW}}</option>
              <option value="{{VisibilityStatus.NOTVISIBLE}}">{{VisibilityStatusText.NOTVISIBLE}}</option>
            </select>
            <p-calendar id="visibility_date" [(ngModel)]="unit.visibility_date" name="visibility_date"
              [iconDisplay]="'input'" [showIcon]="true" dateFormat="mm/dd/yy"
              [disabled]="visibilityDisabled"></p-calendar>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="form-group">
          <div class="d-flex align-items-center gap-2">
            <p-checkbox [(ngModel)]="unit.waitlist" name="waitlist" binary="true"></p-checkbox>
            <label for="waitlist">Waitlist</label>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="form-group">
          <label for="description">Description</label>
          <textarea id="description" pInputTextarea name="description" [(ngModel)]="unit.description"
            class="form-control"></textarea>
        </div>
      </div>

      <div class="col-12">
        <div class="p-field d-flex flex-column mt-3">
          <div class="media-upload-header d-flex align-items-center justify-content-between mb-2">
            <div>
              <label for="media" class="form-label mb-0 fw-semibold">Media Files</label>
              <div class="text-muted small">{{ mediaFiles.length }} / 5 files selected</div>
            </div>
            <p-button type="button" *ngIf="mediaFiles.length > 0" class="primary-btn media-upload-btn"
              [label]="mediaFiles.length > 0 ? 'Upload More Media' : 'Upload Media'" icon="pi pi-upload"
              [disabled]="mediaFiles.length >= 5" (click)="triggerMediaInput()">
            </p-button>
          </div>

          <input id="media" type="file" accept="image/*,video/*" multiple (change)="onMediaSelected($event)"
            class="hidden-file-input" />
          <small class="mt-1 text-muted">Upload up to 5 total media files in any mix of images and videos, 5 MB max
            each.</small>
          <small *ngIf="mediaError" class="text-danger mt-1">{{ mediaError }}</small>
          <small *ngIf="imageError" class="text-danger mt-1">{{ imageError }}</small>
          <small *ngIf="videoError" class="text-danger mt-1">{{ videoError }}</small>

          <div *ngIf="mediaFiles.length === 0"
            class="upload-zone d-flex flex-column align-items-center justify-content-center"
            (click)="triggerMediaInput()">
            <i class="pi pi-cloud-upload upload-icon"></i>
            <span class="upload-label">Click to upload images or videos</span>
            <span class="upload-sub">Up to 5 files total</span>
          </div>

          <div *ngIf="mediaFiles.length > 0" class="mt-3">
            <p-carousel 
              [value]="mediaFiles" 
              [numVisible]="3" 
              [numScroll]="1" 
              [circular]="false"
              [showIndicators]="false" 
              [showNavigators]="mediaFiles.length > 3"
              [responsiveOptions]="mediaCarouselResponsiveOptions" 
              contentClass="custom-carousel">
              <ng-template pTemplate="item" let-media let-i="pIndex">
                <div class="media-thumb-wrapper" (pointerdown)="onPointerDown($event)" 
                (pointermove)="onPointerMove($event)" 
                (pointerup)="onPointerUp($event, i, media)">
                  <img *ngIf="media.type === 'image'" [src]="media.url" [alt]="media.title" class="media-thumb" />
                  <div *ngIf="media.type === 'video'" class="video-thumb">
                    <video [src]="media.url" class="media-thumb" muted playsinline preload="metadata"></video>
                    <div class="video-play-overlay">
                      <i class="pi pi-play-circle"></i>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="thumb-remove-btn p-button p-button-rounded p-button-sm p-button-danger p-button-icon-only"
                    (pointerdown)="onRemoveMediaPointerDown($event, media)"
                    (pointerup)="$event.stopPropagation()"
                    (click)="onRemoveMediaClick($event, media)">
                    <span class="p-button-icon pi pi-times"></span>
                  </button>
                  
                </div>
              </ng-template>
            </p-carousel>
          </div>

        </div>
      </div>

      <div class="mt-3 d-flex justify-content-end">
        <p-button type="submit" class="secondary-btn"
          [disabled]="!unitForm.valid || hasMediaValidationErrors() || !isUnitPriceValid()">Submit</p-button>
      </div>
    </div>
  </form>
</div>

<!-- Full-page Media Dialog -->
<!-- <p-dialog [(visible)]="showMediaModal" [modal]="true" [closable]="false"
  [style]="{ width: '90vw', maxWidth: '960px', maxHeight: '90vh' }"
  [contentStyle]="{ padding: '0', background: '#0f172a', height: '80vh' }" styleClass="media-fullscreen-dialog"
  appendTo="body">

  <p-galleria [(visible)]="showMediaModal" [value]="mediaFiles" [activeIndex]="activeModalIndex"
    [showItemNavigators]="true" [showThumbnails]="true" [showIndicators]="true" [autoPlay]="false" [circular]="true"
    [responsiveOptions]="mediaCarouselResponsiveOptions" styleClass="custom-galleria">

    <ng-template pTemplate="item" let-media>
      <ng-container *ngIf="media.type === 'image'">
        <img [src]="media.src" style="width:100%; height:auto; border-radius:8px;">
      </ng-container>
      <ng-container *ngIf="media.type === 'video'">
        <video [src]="media.src" controls style="width:100%; height:auto; border-radius:8px;"></video>
      </ng-container>
    </ng-template>

    <ng-template pTemplate="thumbnail" let-media>
      <ng-container *ngIf="media.type === 'image'">
        <img [src]="media.src" style="width:100%; height:50px; object-fit:cover; border-radius:4px;">
      </ng-container>
      <ng-container *ngIf="media.type === 'video'">
        <video [src]="media.src" style="width:100%; height:50px; object-fit:cover; border-radius:4px;" muted></video>
      </ng-container>
    </ng-template>

  </p-galleria>
</p-dialog> -->